import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../atoms/label';
import { InputText } from '../atoms/inputText';
import useMedia from 'use-media';
import { TextField } from "@material-ui/core";
import { ComboBox } from '../atoms/comboBox';

export const LabelComboBoxForm = (props) => {
    const {
        id,
        className,
        options,
        getOptionLabel,
        getOptionSelected,
        renderInput,
        renderOption,
        onChange,
        onInputChange,
        onChangeTextFiled,
        onSelect,
        confirmText,
        wrapClassName,
        labelWrap,
        label,
        labelClassName,
        maxLength,
        disabled,
        value,
        defaultValue,
        freeSolo,
        autoSelect,
        disableClearable
    } = props;
    const renderInputBase = (params) => <TextField {...params} maxLength={maxLength} onChange={onChangeTextFiled} InputProps={{...params.InputProps, disableUnderline: true}} />;

    return (
        <div className={confirmText == null ? wrapClassName : labelWrap} >
            <Label label={label} className={labelClassName} />
            {confirmText == null ?
                <ComboBox
                    id={id}
                    className={className}
                    options={options}
                    getOptionLabel={getOptionLabel}
                    getOptionSelected={getOptionSelected}
                    renderInput={renderInput ?? renderInputBase}
                    renderOption={renderOption}
                    onChange={onChange}
                    onInputChange={onInputChange}
                    onSelect={onSelect}
                    disabled={disabled}
                    value={value}
                    defaultValue={defaultValue}
                    freeSolo={freeSolo}
                    autoSelect={autoSelect}
                    disableClearable={disableClearable} /> :
                <Label label={confirmText} className="confirmLabelText" />
            }
        </div>
    );
}
